<template>
  <div>
    <span
      v-if="
        typeof governingDocumentID === 'string' ||
          typeof governingDocumentID === 'number' ||
          documentURL
      "
    >
      <button
        :class="
          isprimary !== undefined && isprimary === true
            ? 'button is-primary is-small is-outline is-rounded'
            : 'button is-info is-light is-small is-outline is-rounded'
        "
        :title="tooltip"
        @click.prevent="downloadPdf(governingDocumentID, documentURL)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    governingDocumentID: [Number, String],
    documentID: [Number, String],
    documentURL: String,
    downloadPdf: Function
  }
}
</script>
